<template>
  <section class="quick-like-container">
    <dl v-for="(item, index) in categoryList.slice(0, 3)" :key="index" :class="{'second': index === 1, 'third': index === 2}">
      <router-link :to="{ name: 'courseOverview', params: {target: sessionTarget, menuCategory: item.categoryId, categoryId: item.categoryId}}">
        <dt>
          <img :src="index === 0 ? newhands : index === 1 ? learning1 : learning2" width="140"/>
        </dt>
        <dd>
          <p class="sub-title">{{index === 0 ? '新手必修' : index === 1 ? '进阶课程' : '高级课程'}}</p>
          <p class="description">{{index === 0 ? '帮助新手告别新手期' : index === 1 ? '全面提升销售表现' : '实现业绩持续增长'}}</p>
        </dd>
      </router-link>
    </dl>
  </section>
</template>

<script>
import newhands from '../../assets/img/newhands-icon.png'
import learning1 from '../../assets/img/learning-cuate-icon.png'
import learning2 from '../../assets/img/learning-cuate-icon2.png'
import { mapState } from 'vuex'
export default {
  name: '',
  data () {
    return {
      newhands,
      learning1,
      learning2
    }
  },
  computed: {
    ...mapState(['categoryList', 'sessionTarget'])
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.quick-like-container{
  display: flex;
  margin-top: 25px;
  margin-left: -12px;
  margin-right: -12px;
  dl {
    flex: 1;
    color: #FF9500;
    background: #fff;
    border-radius: 8px;
    text-align: center;
    min-height: 279px;
    margin-left: 12px;
    margin-right: 12px;
    & a {
      color: #FF9500;
    }
    dt, a dt {
      margin-top: 10px;
    }
    dd, a dd {
      .sub-title {
        font-size: 24px;
        line-height: 34px;
        margin-top: 35px;
        font-weight: bold;
      }
      .description {
        font-size: 16px;
        line-height: 22px;
        margin-top: 5px;
      }
    }
    &.second, &.second a {
      color: #2DBFBE;
    }
    &.third, &.third a {
      color: #FF005C;
    }
  }
}
</style>
